import React from 'react';

import { Icons } from '@components/common';

export const icons = {
	check: <div className='checkIcon'>{Icons.checkIcon()}</div>,
	uncheck: <div className='checkIcon'>{Icons.uncheckIcon()}</div>,
	halfCheck: <div className='checkIcon'>{Icons.halfCheck()}</div>,
	expandClose: <div className='arrowIcon'>{Icons.chevronDown()}</div>,
	expandOpen: <div className='arrowIcon'>{Icons.chevronUp()}</div>,
	expandAll: <div className='arrowIcon'>Icons.chevronUp()</div>,
	collapseAll: <div className='arrowIcon'>Icons.chevronDown()</div>,
	parentClose: <div className='folderIcon'>{Icons.folderIcon()}</div>,
	parentOpen: <div className='folderIcon'>{Icons.folderIcon()}</div>,
	leaf: '',
};
